import { LoadingSpinner, PageLayout } from "lib";
import { useCallback, useEffect, useState } from "react";
import { EventsAPI } from "api_inbusiness";
import { DisplayEventsMinimal } from "lib/components/timeline-minimal";
import Search from "lib/components/Search/Search";

export const VolunteerTickets = () => {
  const [events, setEvents] = useState([]);
  const eventsPerPage = 10;

  const [currentPage, setCurrentPage] = useState(0);
  const [triggerSearch, setTriggerSearch] = useState(false);
  const [triggerRefetch, setTriggerRefetch] = useState(false);

  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  const [isSearch, setIsSearch] = useState(false);

  const [count, setCount] = useState(0);

  const sortEventsDesc = (eventsList) => {
    return [...(eventsList || [])].sort(
      (a, b) => new Date(b.date) - new Date(a.date)
    );
  };

  const getAllEvents = useCallback(() => {
    EventsAPI.getCustomEvents(eventsPerPage, currentPage, 1).then((res) => {
      if (res.ok) {
        setEvents((prev) => sortEventsDesc([...prev, ...res.data.content]));
        setCount(res.data.count);
        setLoading(false);
      } else {
        setEvents([]);
        setCount(0);
        setLoading(false);
      }
    });
  }, [currentPage]);

  const handleMoreEvents = () => {
    setLoading(true);
    setCurrentPage((prev) => prev + 1);
    setLoading(false);
  };

  const searchEvent = () => {
    EventsAPI.searchCustomEvents(search).then((res) => {
      setEvents(sortEventsDesc(res.data.content));
      setLoading(false);
    });
  };

  const getDefaultEvents = () => {
    if (currentPage > 0) {
      setEvents([]);
      setCurrentPage(0);
    } else {
      EventsAPI.getCustomEvents(eventsPerPage, 0, 1).then((res) => {
        if (res.ok) {
          setEvents(sortEventsDesc(res.data.content));
          setCount(res.data.count);
          setCurrentPage(0);
          setLoading(false);
        } else {
          setEvents([]);
          setCount(0);
          setCurrentPage(0);
          setLoading(false);
        }
      });
    }
  };

  const getInitialEvents = () => {
    EventsAPI.getCustomEvents(eventsPerPage, 0, 1).then((res) => {
      setEvents(sortEventsDesc(res.data.content));
      setCount(res.data.count);
      setCurrentPage(0);
      setLoading(false);
    });
  };

  useEffect(() => {
    getAllEvents();
  }, [currentPage]);
  return (
    <>
      <PageLayout
        title={"Bilete"}
        subTitle={"Vezi biletele tale"}
        actionArea={
          <>
            <Search
              isSearch={isSearch}
              setIsSearch={setIsSearch}
              search={search}
              setSearch={setSearch}
              nameToFind={"Caută eveniment"}
              triggerRefetch={triggerRefetch}
              setTriggerRefetch={setTriggerRefetch}
              triggerSearch={triggerSearch}
              setTriggerSearch={setTriggerSearch}
              setLoading={setLoading}
              setterFunction={setEvents}
              defaultGet={getDefaultEvents}
              searchGet={searchEvent}
            />
          </>
        }
      >
        {loading ? (
          <LoadingSpinner margin="5rem auto" loading={loading} />
        ) : (
          <DisplayEventsMinimal
            events={events}
            getAllEvents={getInitialEvents}
            handleMoreEvents={handleMoreEvents}
            search={search}
            hasMore={!isSearch && count > events.length}
          />
        )}
      </PageLayout>
    </>
  );
};
